// Polish translations (default)
export const translations = {
  pl: {
    // Navigation
    menu: 'menu',
    back: 'Wróć',
    tournament: 'turniej rankingowy',
    tournamentStats: 'statystyki turniejów',
    training: 'trening',
    friendlyGame: 'mecz towarzyski',
    
    // Tournament Stats
    shootMe: 'ShootMe',
    allTournaments: 'Wszystkie turnieje',
    tournamentsThisYear: 'Turnieje tegoroczne',
    allGames: 'Wszystkie mecze',
    gamesThisYear: 'Mecze tegoroczne',
    firstPlaces: 'Pierwsze miejsca',
    secondPlaces: 'Drugie miejsca',
    thirdPlaces: 'Trzecie miejsca',
    topTenPlaces: 'Miejsca w pierwszej dziesiątce',
    percentileDescription: 'zawodników grających w tych samych turniejach',
    thisYearPercentileDescription: 'zawodników grających w tych samych turniejach (średnia z wszystkich turniejów w',
    percentileChart: 'Percentyl w ostatnich 50 turniejach (średnia krocząca)',
    tournamentPercentile: 'Percentyl turnieju',
    averagePercentile: 'Średni percentyl',
    tournamentComparison: 'Porównanie percentyli turniejowych',
    tournamentsChronologically: 'Turnieje (chronologicznie)',
    percentile: 'Percentyl (%)',
    
    // Loading and errors
    loadingStats: 'Ładowanie statystyk...',
    connectionError: 'Błąd połączenia:',
    authError: 'Brak tokenu autoryzacji. Zaloguj się ponownie.',
    validatingSession: 'Weryfikacja sesji...',
    
    // Language names
    polish: 'Polski',
    english: 'English',
    french: 'Français',
    
    // Login page
    appDescription: 'Aplikacja do śledzenia i analizy wyników treningów petanque',
    login: 'Logowanie',
    email: 'Email',
    password: 'Password',
    loginButton: 'Logowanie',
    forgotPassword: 'Nie pamiętam hasła',
    loginSuccessful: 'Logowanie pomyślne!',
    loginFailed: 'Logowanie nieudane.',
    serverError: 'Błąd połączenia z serwerem.',
    
    // Main page
    mainMenu: 'menu',
    training: 'trening',
    friendlyGame: 'mecz towarzyski',
    tournament: 'turniej rankingowy',
    settings: 'ustawienia',
    
    // Pre-login page
    loginButton: 'Zaloguj się',
    registerButton: 'Zarejestruj się',
    card1Title: 'Graj. Zapisuj. Rozwijaj się.',
    card1Description: 'Śledź każdy rzut i trafienie',
    card2Title: 'Opanuj celność',
    card2Description: 'Z łatwością zapisuj wyniki treningów strzałów i puent',
    card3Title: 'Czas na grę!',
    card3Description: 'Dodawaj wyniki meczów towarzyskich i turniejowych',
    card4Title: 'Twoje statystyki, twoja historia',
    card4Description: 'Poznaj swoją celność, trendy, serie zwycięstw',
    card5Title: 'Wejdź na wyższy poziom',
    card5Description: 'Obserwuj rozwój i ciesz się każdym małym sukcesem',
    
    // Registration page
    registration: 'Rejestracja',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    password: 'Hasło',
    repeatPassword: 'Powtórz hasło',
    registerButton: 'Rejestracja',
    firstNameError: 'Imię musi mieć co najmniej 2 znaki',
    lastNameError: 'Nazwisko musi mieć co najmniej 2 znaki',
    passwordError: 'Hasło musi mieć co najmniej 8 znaków',
    passwordDigitError: 'Hasło musi zawierać co najmniej jedną cyfrę',
    passwordSpecialError: 'Hasło musi zawierać co najmniej jeden znak specjalny',
    passwordMismatchError: 'Hasła nie są identyczne',
    passwordHint: 'Hasło musi mieć co najmniej 8 znaków, zawierać cyfrę i znak specjalny',
    registrationFailed: 'Rejestracja nie powiodła się.',
    serverError: 'Błąd połączenia z serwerem.',
    
    // Main menu buttons
    logout: 'wyloguj',
    deleteAccount: 'usuń konto',
    
    // Training page
    trainingPage: 'trening',
    shotAtBall: 'strzał w kulę',
    shotAtPig: 'strzał w świnkę',
    highPoint: 'puenta wysoka',
    lowPoint: 'puenta niska',
    trainingReview: 'przegląd treningów',
    trainingStats: 'statystyki treningów',
    
    // Breadcrumbs
    '': 'menu',
    'trening': 'trening',
    'strzal-w-kule': 'strzał w kulę',
    'strzal-w-swinke': 'strzał w świnkę',
    'puenta-wysoka': 'puenta wysoka',
    'puenta-niska': 'puenta niska',
    'przeglad': 'przegląd treningów',
    'statystyki': 'statystyki treningów',
    'statystyki-meczow': 'statystyki meczów',
    'mecz': 'mecz',
    'turniej-rankingowy': 'turniej rankingowy',
    'dodaj': 'dodaj turniej',
    'szczegoly': 'szczegóły turnieju',
    'dodaj-runde': 'dodaj rundę',
    'zakoncz': 'zakończ turniej',
    'mecze': 'przegląd meczów turniejowych',
    'mecz-towarzyski': 'mecz towarzyski',
    'dodaj-mecz': 'dodaj mecz',
    'przeglad-meczow': 'przegląd meczów',
    'wynik': 'Wynik',
    'ustawienia': 'ustawienia',
    'usun-konto': 'usuwanie konta',
    'rejestracja': 'rejestracja',
    'logowanie': 'logowanie',
    
    // Shot at Boule training page
    terrain: 'Teren',
    weather: 'Pogoda',
    temperature: 'Temperatura',
    date: 'Data',
    time: 'Godzina',
    selectOption: 'Wybierz...',
    distance: 'odległość',
    carreau: 'carreau',
    hit: 'trafiony',
    touch: 'dotknięcie',
    missed: 'nietrafiony',
    totalShots: 'suma rzutów',
    totalAllShots: 'suma wszystkich rzutów',
    saveTraining: 'Zapisz trening',
    trainingSaved: 'Trening zapisany!',
    dateRequired: 'Data jest wymagana.',
    saveError: 'Błąd zapisu treningu',
    serverConnectionError: 'Błąd połączenia z serwerem.',
    
    // Pointing training page columns
    '<20 cm': '<20 cm',
    '21-50 cm': '21-50 cm',
    '>50cm': '>50cm',
    
    // Calendar and training review
    clickDayForDetails: 'Kliknij dzień w kółku, aby zobaczyć szczegóły treningu.',
    edit: 'Edytuj',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    deleteTraining: 'Usuń trening',
    deleteTrainingConfirmation: 'Czy na pewno chcesz usunąć ten trening?',
    trainingUpdated: 'Trening został zaktualizowany!',
    trainingDeleted: 'Trening został usunięty!',
    noTrainingsDay: 'Brak treningu w wybranym dniu.',
    trainingDetails: 'Szczegóły treningu:',
    months: {
      'January': 'Styczeń',
      'February': 'Luty',
      'March': 'Marzec',
      'April': 'Kwiecień',
      'May': 'Maj',
      'June': 'Czerwiec',
      'July': 'Lipiec',
      'August': 'Sierpień',
      'September': 'Wrzesień',
      'October': 'Październik',
      'November': 'Listopad',
      'December': 'Grudzień'
    },
    
    // Statistics page
    training: 'trening',
    range: 'zakres',
    statistics: 'statystyka',
    distance: 'odległość',
    day: 'dzień',
    week: 'tydzień',
    month: 'miesiąc',
    year: 'rok',
    hitCount: 'ilość trafień',
    hitPercentage: '% trafień',
    throwCount: 'ilość rzutów',
    all: 'wszystkie',
    noData: 'Brak danych do wyświetlenia',
    forSelectedCriteria: 'dla wybranych kryteriów',
    chartTitle: 'Statystyki treningu',
    shotAtBoule: 'strzał w kulę',
    shotAtCochonnet: 'strzał w świnkę',
    highPointing: 'puenta wysoka',
    lowPointing: 'puenta niska',
    
    // Chart legend labels
    carreau: 'carreau',
    carreauHit: 'carreau + trafienie',
    carreauHitTouch: 'carreau + trafienie + dotknięcie',
    hit: 'trafienie',
    hitTouch: 'trafienie + dotknięcie',
    throwCount: 'ilość rzutów',
    under20cm: '<20 cm',
    under50cm: '0-50 cm',
    over50cm: '>50 cm',
    
    // Friendly Game translations
    singiel: 'Singiel',
    dublet: 'Dublet',
    triplet: 'Triplet',
    twojaDruzyna: 'Twoja Drużyna',
    druzynaPrzeciwna: 'Drużyna Przeciwna',
    gracz: 'Gracz',
    rozpocznijMecz: 'Rozpocznij Mecz',
    wypelnijPola: 'Wypełnij wszystkie pola (min. 3 znaki)',
    zapisz: 'Zapisz',
    zapisywanie: 'Zapisywanie...',
    anuluj: 'Anuluj',
    edytuj: 'Edytuj',
    usun: 'Usuń',
    filtruj: 'Filtruj',
    wyczysc: 'Wyczyść',
    brakDanych: 'Brak danych do wyświetlenia. Dodaj mecze, aby zobaczyć statystyki.',
    ladowanieDanych: 'Ładowanie danych...',
    bladLadowania: 'Błąd ładowania statystyk',
    sprobujPonownie: 'Spróbuj ponownie',
    przejdzDoStronyGlownej: 'Przejdź do strony głównej',
    pokazaneOstatnie: 'Pokazane ostatnie 100 meczów z',
    dostepnych: 'dostępnych',
    pokazaneWszystkie: 'Pokazane wszystkie',
    meczow: 'meczów',
    wszystkie: 'wszystkie',
    rok: 'Rok',
    miesiac: 'Miesiąc',
    
    // Error messages
    wszyscyGraczeMin3Znaki: 'Wszyscy gracze muszą mieć co najmniej 3 znaki w imieniu',
    petanqueNieMaRemisow: 'W petanque nie ma remisów! Wyniki obu drużyn muszą się różnić.',
    wystapilBladZapisywania: 'Wystąpił błąd podczas zapisywania gry',
    
    // Placeholder texts
    zalogowanyUzytkownik: 'Zalogowany użytkownik',
    wprowadzImieGracza: 'Wprowadź imię gracza',
    // Review page translations
    filtry: 'Filtry',
    gracz2: 'Gracz 2',
    gracz3: 'Gracz 3',
    przeciwnik1: 'Przeciwnik 1',
    przeciwnik2: 'Przeciwnik 2',
    przeciwnik3: 'Przeciwnik 3',
    dataOd: 'Data od',
    dataDo: 'Data do',
    liczbaGraczy: 'Liczba graczy',
    wszystkie: 'Wszystkie',
    single: 'Single',
    dublety: 'Dublety',
    triplety: 'Triplety',
    brakMeczyKryteria: 'Brak meczy spełniających kryteria wyszukiwania',
    dataICzas: 'Data i czas',
    gracz1: 'Gracz 1',
    akcje: 'Akcje',
    brakTokenuAutoryzacji: 'Brak tokenu autoryzacji. Zaloguj się ponownie.',
    bladStatus: 'Błąd {status}: {text}',
    ladowanieDanychReview: 'Ładowanie danych...',
    bladReview: 'Błąd: {error}',
    // Stats page translations
    sredniePunktyWCzasie: 'Średnie punkty w czasie',
    sredniePunktyZdobyte: 'Średnie punkty zdobyte',
    sredniePunktyStracone: 'Średnie punkty stracone',
    numerMeczu: 'Numer meczu',
    sredniePunkty: 'Średnie punkty',
    lacznieMeczow: 'Łącznie meczów',
    mecz: 'Mecz',
    pktZdobyte: 'pkt zdobyte',
    srednia: 'Średnia',
    pktStracone: 'pkt stracone',
    wygrane: 'Wygrane',
    przegrane: 'Przegrane',
    lacznie: 'Łącznie',
    zakresCzasowy: 'Zakres czasowy',
    statystykiWygranychPrzegranych: 'Statystyki wygranych i przegranych',
    nieMoznaOdczytaćOdpowiedzi: 'Nie można odczytać odpowiedzi serwera',
    // Tournament translations
    'turniej-rankingowy': 'turniej rankingowy',
    'dodaj-turniej': 'dodaj turniej',
    'przeglad-turniejow': 'przegląd turniejów',
    'przeglad-meczow-turniejowych': 'przegląd meczów turniejowych',
    'statystyki-turniejow': 'statystyki turniejów',
    'statystyki-meczow-turniejowych': 'statystyki meczów turniejowych',
    'szczegoly-turnieju': 'szczegóły turnieju',
    'zakoncz-turniej': 'zakończ turniej',
    'dodaj-runde': 'dodaj rundę',
    'rundy': 'rundy',
    // AddTournament specific translations
    'turnieje-w-trakcie-rozgrywek': 'Turnieje w trakcie rozgrywek',
    'brak-turniejow-w-trakcie': 'Brak turniejów w trakcie rozgrywek',
    'szczegoly': 'Szczegóły',
    'edytuj': 'Edytuj',
    'usun': 'Usuń',
    'data': 'Data',
    'miasto': 'Miasto',
    'nazwa-turnieju': 'Nazwa turnieju',
    'typ': 'Typ',
    'ilosc-graczy': 'Ilość graczy',
    'gracz2': 'Gracz 2',
    'gracz3': 'Gracz 3',
    'rezerwowy': 'Rezerwowy',
    'rezerwowy-przeciwnik': 'Rezerwowy przeciwnik',
    'miejsce': 'Miejsce',
    'typ-rundy': 'Typ rundy',
    'data-od': 'Data od',
    'data-do': 'Data do',
    'dodaj-turniej-button': 'Dodaj turniej',
    'dodaj-nowy-turniej': 'Dodaj nowy turniej',
    'data-required': 'Data *',
    'nazwa-turnieju-required': 'Nazwa turnieju *',
    'miasto-required': 'Miasto *',
    'typ-required': 'Typ *',
    'gracz2-required': 'Gracz 2 *',
    'gracz3-required': 'Gracz 3 *',
    'single': 'Single',
    'dublety': 'Dublety',
    'triplety': 'Triplety',
    'triplety-z-rezerwowym': 'Triplety z rezerwowym',
    'anuluj': 'Anuluj',
    'dodawanie': 'Dodawanie...',
    'dodaj': 'Dodaj',
    'potwierdzenie-usuniecia': 'Potwierdzenie usunięcia',
    'usuniecie-potwierdzenie-tekst': 'Za chwilę trwale usuniesz dane turnieju. Jesteś pewien?',
    'nie': 'Nie',
    'tak': 'Tak',
    'nieznany': 'Nieznany',
    'wybierz-typ-rundy': 'Wybierz typ rundy',
    'wprowadz-wyniki-dla-obu-druzyn': 'Wprowadź wyniki dla obu drużyn',
    'wyniki-musza-byc-liczbami': 'Wyniki muszą być liczbami',
    'wyniki-musza-byc-miedzy-0-a-13': 'Wyniki muszą być między 0 a 13',
    'petanque-nie-ma-remisow': 'W petanque nie ma remisów! Wyniki obu drużyn muszą się różnić.',
    'zapisywanie': 'Zapisywanie...',
    'zapisz-zmiany': 'Zapisz zmiany',
    'usuwanie': 'Usuwanie...',
    'tak': 'Tak',
    'rundy-turnieju': 'Rundy turnieju',
    'dodaj-pierwsza-runde': 'Dodaj pierwszą rundę',
    'typ-rundy': 'Typ rundy',
    'wprowadz-nazwe-przeciwnika1': 'Wprowadź nazwę Przeciwnika 1',
    'wprowadz-nazwe-przeciwnika2': 'Wprowadź nazwę Przeciwnika 2',
    'wprowadz-nazwe-przeciwnika3': 'Wprowadź nazwę Przeciwnika 3',
    'wprowadz-nazwe-rezerwowego': 'Wprowadź nazwę Rezerwowego',
    'zapisz-runde': 'Zapisz rundę',
    'dodaj-runde': 'Dodaj rundę',
    'dodaj-runde-breadcrumb': 'dodaj rundę',
    'runda-buchholza': 'Runda Buchholza',
    'runda-pucharowa': 'Runda pucharowa',
    'runda-grupowa': 'Runda grupowa',
    'moja-druzyna': 'Moja drużyna',
    'przeciwnicy': 'Przeciwnicy',
    'runda': 'Runda',
    'puchar-buchholz-grupa': 'Puchar/Buchholz/Grupa',
    'punkty-zdobyte': 'Punkty zdobyte',
    'punkty-stracone': 'Punkty stracone',
    'edytuj-runde': 'Edytuj rundę',
    'zakoncz-turniej': 'Zakończ turniej',
    'wybierz-typ': 'Wybierz typ',
    'przeglad-turniejow': 'przegląd turniejów',
    'zakonczone-turnieje': 'Zakończone turnieje',
    'filtry': 'Filtry',
    'nazwa-turnieju-wymagana': 'Nazwa turnieju jest wymagana',
    'miasto-wymagane': 'Miasto jest wymagane',
    'liczba-graczy-od': 'Liczba graczy od',
    'liczba-graczy-do': 'Liczba graczy do',
    'brak-zakonczonych-turniejow': 'Brak zakończonych turniejów',
    'brak-turniejow-spelniajacych-kryteria': 'Brak turniejów spełniających kryteria wyszukiwania',
    'typ-turnieju': 'Typ turnieju',
    'wszystkie': 'Wszystkie',
    'twoja-druzyna': 'Twoja Drużyna',
    'moja-druzyna-section': 'Moja Drużyna',
    'wyniki-meczu-zapisane': 'Wyniki meczu zostały zapisane w bazie danych.',
    'wynik-breadcrumb': 'wynik',
    'gra-zostala-pomyslnie-zapisana': 'Gra została pomyślnie zapisana!',
    
    // Tournament Matches Page
    'przeglad-meczow-turniejowych': 'przegląd meczów turniejowych',
    'ladowanie-meczow': 'Ładowanie meczów...',
    'filtry': 'Filtry',
    'gracz3': 'Gracz 3',
    'rezerwowy': 'Rezerwowy',
    'przeciwnik1': 'Przeciwnik 1',
    'przeciwnik2': 'Przeciwnik 2',
    'przeciwnik3': 'Przeciwnik 3',
    'rezerwowy-przeciwnik': 'Rezerwowy przeciwnik',
    'liczba-graczy': 'Liczba graczy',
    'wszystkie': 'Wszystkie',
    'single': 'Single',
    'dublety': 'Dublety',
    'triplety': 'Triplety',
    'triplety-z-rezerwowym': 'Triplety z rezerwowym',
    'typ-rundy': 'Typ rundy',
    'grupowa': 'Grupowa',
    'pucharowa': 'Pucharowa',
    'buchholz': 'Buchholz',
    'mecze-turniejowe': 'Mecze turniejowe',
    'brak-meczow-spelniajacych-kryteria': 'Brak meczów spełniających kryteria wyszukiwania',
    'edytuj': 'Edytuj',
    'usun': 'Usuń',
    'czy-na-pewno-usunac-mecz': 'Czy na pewno chcesz usunąć ten mecz?',
    'blad-podczas-zapisywania': 'Błąd podczas zapisywania',
    'blad-podczas-usuwania': 'Błąd podczas usuwania',
    'brak-tokenu-autoryzacji': 'Brak tokenu autoryzacji. Zaloguj się ponownie.',
    'blad': 'Błąd',
    
    // Confirmation Modal
    'potwierdz-usuniecie': 'Potwierdź usunięcie',
    'czy-na-pewno-usunac-mecz': 'Czy na pewno chcesz usunąć ten mecz?',
    'anuluj': 'Anuluj',
    'usun': 'Usuń',
    
    // Tournament Statistics Page
    'statystyki-turniejow': 'statystyki turniejów',
    
    // Tournament Match Statistics Page
    'statystyki-meczow-turniejowych': 'statystyki meczów turniejowych',
    'ladowanie-danych': 'Ładowanie danych...',
    'blad-ladowania-statystyk': 'Błąd ładowania statystyk',
    'sprobuj-ponownie': 'Spróbuj ponownie',
    'zakres-czasowy': 'Zakres czasowy',
    'wszystkie': 'Wszystkie',
    'rok': 'Rok',
    'miesiac': 'Miesiąc',
    'typ': 'Typ',
    'buchholz': 'Buchholz',
    'pucharowe': 'Pucharowe',
    'grupowe': 'Grupowe',
    'wszystkie-mecze': 'Wszystkie mecze',
    'single': 'Single',
    'dublety': 'Dublety',
    'triplety': 'Triplety',
    'wygrane': 'Wygrane',
    'przegrane': 'Przegrane',
    'lacznie': 'Łącznie',
    'meczow': 'meczów',
    'srednie-punkty-w-czasie': 'Średnie punkty w czasie',
    'punkty-zdobyte': 'Punkty zdobyte',
    'punkty-stracone': 'Punkty stracone',
    'numer-meczu': 'Numer meczu',
    'srednie-punkty': 'Średnie punkty',
    'lacznie-meczow': 'Łącznie meczów',
    'brak-danych-do-wyswietlenia': 'Brak danych do wyświetlenia',
    'dodaj-mecze-aby-zobaczyc-statystyki': 'Dodaj mecze, aby zobaczyć statystyki',
    'mecz': 'Mecz',
    'pkt-zdobyte': 'pkt zdobyte',
    'srednia': 'Średnia',
    'pkt-stracone': 'pkt stracone',
    // Settings Page
    'ustawienia': 'ustawienia',
    'ustawienia-profilu-uzytkownika': 'Ustawienia profilu użytkownika',
    'ladowanie': 'Ładowanie...',
    'imie': 'Imię',
    'nazwisko': 'Nazwisko',
    'numer-licencji': 'Numer licencji',
    'klub': 'Klub',
    'wybierz-klub': 'Wybierz klub',
    'miasto': 'Miasto',
    'edytuj': 'Edytuj',
    'zapisz': 'Zapisz',
    'anuluj': 'Anuluj',
    'profil-zostal-zaktualizowany-pomyslnie': 'Profil został zaktualizowany pomyślnie',
    'blad-aktualizacji-profilu': 'Błąd aktualizacji profilu',
    'imie-i-nazwisko-sa-obowiazkowe': 'Imię i nazwisko są obowiązkowe',
    'blad-pobierania-profilu-uzytkownika': 'Błąd pobierania profilu użytkownika',
    'blad-pobierania-listy-klubow': 'Błąd pobierania listy klubów',
    // Account Deletion Page
    'usun-konto': 'usun konto',
    'czy-jestes-pewien-usunac-konto': 'Czy jesteś pewien, że chcesz usunąć swoje konto? Jest to nieodwracalny proces, po którym Twoje dane zostaną usunięte z aplikacji.',
    'tak': 'Tak',
    'nie': 'Nie',
    // Registration Success Page
    'rejestracja-zakonczona-pomyslnie': 'Rejestracja zakończona pomyślnie',
    'rejestracja-zakonczona': 'Rejestracja zakończona!',
    'dziekujemy-za-rejestracje': 'Dziękujemy za rejestrację! Wysłaliśmy email weryfikacyjny na podany adres.',
    'aby-aktywowac-konto': 'Aby aktywować swoje konto, sprawdź swoją skrzynkę email i kliknij link weryfikacyjny.',
    'po-weryfikacji-emaila': 'Po weryfikacji emaila będziesz mógł się zalogować do aplikacji.',
    'przejdz-do-strony-glownej': 'Przejdź do strony głównej',
    
    // Email verification page
    'email-verification': 'Weryfikacja Emaila',
    'invalid-verification-link': 'Nieprawidłowy link weryfikacyjny. Sprawdź swój email i spróbuj ponownie.',
    'verifying-email': 'Weryfikowanie Emaila...',
    'please-wait-verification': 'Proszę czekać podczas weryfikacji adresu email.',
    'email-verified': 'Email Zweryfikowany!',
    'email-verified-success': 'Email został zweryfikowany pomyślnie! Możesz się teraz zalogować do swojego konta.',
    'email-already-verified-success': 'Email został już zweryfikowany wcześniej. Możesz się teraz zalogować do swojego konta.',
    'verification-failed': 'Weryfikacja nie powiodła się. Spróbuj ponownie.',
    'verification-failed-title': 'Weryfikacja Nie Powiodła Się',
    'contact-support-resend': 'Skontaktuj się z pomocą techniczną, aby ponownie wysłać email weryfikacyjny.',
    'resend-email': 'Wyślij Email Ponownie',
    
    // Forgot Password page
    'password-reset': 'Resetowanie hasła',
    'forgot-password-title': 'Nie pamiętam hasła',
    'forgot-password-description': 'Wprowadź swój adres email, a wyślemy Ci link do resetowania hasła.',
    'reset-password-button': 'Zresetuj hasło',
    'password-reset-link-sent': 'Link do resetowania hasła został wysłany na podany adres email.',
    'password-reset-error-sending': 'Wystąpił błąd podczas wysyłania linku.',
    'back-to-login': 'Powrót do logowania',
    'sending': 'Wysyłanie...',
    
    // Reset Password page
    'set-new-password': 'Ustaw nowe hasło',
    'new-password': 'Nowe hasło',
    'repeat-password': 'Powtórz hasło',
    'password-requirements': 'Hasło musi mieć co najmniej 8 znaków, zawierać cyfrę i znak specjalny',
    'change-password': 'Zmień hasło',
    'saving': 'Zapisywanie...',
    'invalid-reset-link': 'Nieprawidłowy link do resetowania hasła.',
    'password-reset-error': 'Wystąpił błąd podczas resetowania hasła.',
    'request-new-link': 'Poproś o nowy link',
    'error': 'Błąd',
    
    // Password Reset Success page
    'password-changed-successfully': 'Hasło zostało zmienione pomyślnie',
    'success': 'Sukces',
    'password-changed-message': 'Twoje hasło zostało pomyślnie zmienione. Możesz teraz zalogować się używając nowego hasła.',
    'go-to-login': 'Przejdź do logowania',
    'main-page': 'Strona główna',
  },
  
  en: {
    // Navigation
    menu: 'menu',
    back: 'Back',
    tournament: 'ranking tournament',
    tournamentStats: 'tournament statistics',
    training: 'training',
    friendlyGame: 'friendly game',
    
    // Tournament Stats
    shootMe: 'ShootMe',
    allTournaments: 'All tournaments',
    tournamentsThisYear: 'This year tournaments',
    allGames: 'All games',
    gamesThisYear: 'This year games',
    firstPlaces: 'First places',
    secondPlaces: 'Second places',
    thirdPlaces: 'Third places',
    topTenPlaces: 'Top ten places',
    percentileDescription: 'players playing in the same tournaments',
    thisYearPercentileDescription: 'players playing in the same tournaments (average from all tournaments in',
    percentileChart: 'Percentile in last 50 tournaments (moving average)',
    tournamentPercentile: 'Tournament percentile',
    averagePercentile: 'Average percentile',
    tournamentComparison: 'Tournament percentile comparison',
    tournamentsChronologically: 'Tournaments (chronologically)',
    percentile: 'Percentile (%)',
    
    // Loading and errors
    loadingStats: 'Loading statistics...',
    connectionError: 'Connection error:',
    authError: 'No authorization token. Please log in again.',
    validatingSession: 'Validating session...',
    
    // Language names
    polish: 'Polski',
    english: 'English',
    french: 'Français',
    
    // Login page
    appDescription: 'Application for tracking and analyzing petanque training results',
    login: 'Login',
    email: 'Email',
    password: 'Password',
    loginButton: 'Login',
    forgotPassword: 'Forgot password',
    loginSuccessful: 'Login successful!',
    loginFailed: 'Login failed.',
    serverError: 'Error connecting to server.',
    
    // Main page
    mainMenu: 'menu',
    training: 'training',
    friendlyGame: 'friendly game',
    tournament: 'ranking tournament',
    settings: 'settings',
    
    // Pre-login page
    loginButton: 'Log In',
    registerButton: 'Register',
    card1Title: 'Play. Record. Improve.',
    card1Description: 'Track every throw and hit',
    card2Title: 'Master accuracy',
    card2Description: 'Easily record shooting and pointing training results',
    card3Title: 'Time to play!',
    card3Description: 'Add friendly and tournament match results',
    card4Title: 'Your statistics, your history',
    card4Description: 'Discover your accuracy, trends, winning streaks',
    card5Title: 'Level up',
    card5Description: 'Watch your progress and enjoy every small success',
    
    // Registration page
    registration: 'Registration',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    repeatPassword: 'Repeat Password',
    registerButton: 'Register',
    firstNameError: 'First name must be at least 2 characters',
    lastNameError: 'Last name must be at least 2 characters',
    passwordError: 'Password must be at least 8 characters',
    passwordDigitError: 'Password must contain at least one digit',
    passwordSpecialError: 'Password must contain at least one special character',
    passwordMismatchError: 'Passwords do not match',
    passwordHint: 'Password must be at least 8 characters, contain a digit and special character',
    registrationFailed: 'Registration failed.',
    serverError: 'Error connecting to server.',
    
    // Main menu buttons
    logout: 'logout',
    deleteAccount: 'delete account',
    
    // Training page
    trainingPage: 'training',
    shotAtBall: 'shot at boule',
    shotAtPig: 'shot at cochonnet',
    highPoint: 'high pointing',
    lowPoint: 'low pointing',
    trainingReview: 'training review',
    trainingStats: 'training statistics',
    
    // Breadcrumbs
    '': 'menu',
    'trening': 'training',
    'strzal-w-kule': 'shot at boule',
    'strzal-w-swinke': 'shot at cochonnet',
    'puenta-wysoka': 'high pointing',
    'puenta-niska': 'low pointing',
    'przeglad': 'training review',
    'statystyki': 'training statistics',
    'statystyki-meczow': 'match statistics',
    'mecz': 'match',
    'turniej-rankingowy': 'ranking tournament',
    'dodaj': 'add tournament',
    'szczegoly': 'tournament details',
    'dodaj-runde': 'add round',
    'zakoncz': 'finish tournament',
    'mecze': 'tournament matches review',
    'mecz-towarzyski': 'friendly game',
    'dodaj-mecz': 'add match',
    'przeglad-meczow': 'matches review',
    'wynik': 'Result',
    'ustawienia': 'settings',
    'usun-konto': 'delete account',
    'rejestracja': 'registration',
    'logowanie': 'login',
    
    // Shot at Boule training page
    terrain: 'Terrain',
    weather: 'Weather',
    temperature: 'Temperature',
    date: 'Date',
    time: 'Time',
    selectOption: 'Select...',
    distance: 'distance',
    carreau: 'carreau',
    hit: 'hit',
    touch: 'touch',
    missed: 'missed',
    totalShots: 'total throws',
    totalAllShots: 'total all throws',
    saveTraining: 'Save training',
    trainingSaved: 'Training saved!',
    dateRequired: 'Date is required.',
    saveError: 'Training save error',
    serverConnectionError: 'Server connection error.',
    
    // Training review page
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    deleteTraining: 'Delete training',
    deleteTrainingConfirmation: 'Are you sure you want to delete this training?',
    trainingUpdated: 'Training has been updated!',
    trainingDeleted: 'Training has been deleted!',
    noTrainingsDay: 'No training on the selected day.',
    trainingDetails: 'Training details:',
    
    // Pointing training page columns
    '<20 cm': '<20 cm',
    '21-50 cm': '21-50 cm',
    '>50cm': '>50cm',
    
    // Calendar and training review
    clickDayForDetails: 'Click on a circled day to view training details.',
    months: {
      'January': 'January',
      'February': 'February',
      'March': 'March',
      'April': 'April',
      'May': 'May',
      'June': 'June',
      'July': 'July',
      'August': 'August',
      'September': 'September',
      'October': 'October',
      'November': 'November',
      'December': 'December'
    },
    
    // Statistics page
    training: 'training',
    range: 'range',
    statistics: 'statistics',
    distance: 'distance',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    hitCount: 'hit count',
    hitPercentage: 'hit %',
    throwCount: 'throw count',
    all: 'all',
    noData: 'No data to display',
    forSelectedCriteria: 'for selected criteria',
    chartTitle: 'Training statistics',
    shotAtBoule: 'shot at boule',
    shotAtCochonnet: 'shot at cochonnet',
    highPointing: 'high pointing',
    lowPointing: 'low pointing',
    
    // Chart legend labels
    carreau: 'carreau',
    carreauHit: 'carreau + hit',
    carreauHitTouch: 'carreau + hit + touch',
    hit: 'hit',
    hitTouch: 'hit + touch',
    throwCount: 'throw count',
    under20cm: '<20 cm',
    under50cm: '0-50 cm',
    over50cm: '>50 cm',
    
    // Friendly Game translations
    singiel: 'Singles',
    dublet: 'Doubles',
    triplet: 'Triples',
    twojaDruzyna: 'Your Team',
    druzynaPrzeciwna: 'Opponent Team',
    gracz: 'Player',
    rozpocznijMecz: 'Start Match',
    wypelnijPola: 'Fill all fields (min. 3 characters)',
    zapisz: 'Save',
    zapisywanie: 'Saving...',
    anuluj: 'Cancel',
    edytuj: 'Edit',
    usun: 'Delete',
    filtruj: 'Filter',
    wyczysc: 'Clear',
    brakDanych: 'No data to display. Add matches to see statistics.',
    ladowanieDanych: 'Loading data...',
    bladLadowania: 'Error loading statistics',
    sprobujPonownie: 'Try again',
    przejdzDoStronyGlownej: 'Go to main page',
    pokazaneOstatnie: 'Showing last 100 matches out of',
    dostepnych: 'available',
    pokazaneWszystkie: 'Showing all',
    meczow: 'matches',
    wszystkie: 'all',
    rok: 'Year',
    miesiac: 'Month',
    
    // Error messages
    wszyscyGraczeMin3Znaki: 'All players must have at least 3 characters in their name',
    petanqueNieMaRemisow: 'In petanque there are no draws! Both teams\' scores must be different.',
    wystapilBladZapisywania: 'An error occurred while saving the game',
    
    // Placeholder texts
    zalogowanyUzytkownik: 'Logged in user',
    wprowadzImieGracza: 'Enter player name',
    // Review page translations
    filtry: 'Filters',
    gracz2: 'Player 2',
    gracz3: 'Player 3',
    przeciwnik1: 'Opponent 1',
    przeciwnik2: 'Opponent 2',
    przeciwnik3: 'Opponent 3',
    dataOd: 'Date from',
    dataDo: 'Date to',
    liczbaGraczy: 'Number of players',
    wszystkie: 'All',
    single: 'Single',
    dublety: 'Doubles',
    triplety: 'Triples',
    brakMeczyKryteria: 'No matches meet the search criteria',
    dataICzas: 'Date and time',
    gracz1: 'Player 1',
    akcje: 'Actions',
    brakTokenuAutoryzacji: 'No authorization token. Please log in again.',
    bladStatus: 'Error {status}: {text}',
    ladowanieDanychReview: 'Loading data...',
    bladReview: 'Error: {error}',
    // Stats page translations
    sredniePunktyWCzasie: 'Average points over time',
    sredniePunktyZdobyte: 'Average points scored',
    sredniePunktyStracone: 'Average points conceded',
    numerMeczu: 'Match number',
    sredniePunkty: 'Average points',
    lacznieMeczow: 'Total matches',
    mecz: 'Match',
    pktZdobyte: 'pts scored',
    srednia: 'Average',
    pktStracone: 'pts conceded',
    wygrane: 'Won',
    przegrane: 'Lost',
    lacznie: 'Total',
    zakresCzasowy: 'Time range',
    statystykiWygranychPrzegranych: 'Win and loss statistics',
    nieMoznaOdczytaćOdpowiedzi: 'Cannot read server response',
    // Tournament translations
    'turniej-rankingowy': 'ranking tournament',
    'dodaj-turniej': 'add tournament',
    'przeglad-turniejow': 'tournament review',
    'przeglad-meczow-turniejowych': 'tournament matches review',
    'statystyki-turniejow': 'tournament statistics',
    'statystyki-meczow-turniejowych': 'tournament match statistics',
    'szczegoly-turnieju': 'tournament details',
    'zakoncz-turniej': 'finish tournament',
    'dodaj-runde': 'add round',
    'rundy': 'rounds',
    // AddTournament specific translations
    'turnieje-w-trakcie-rozgrywek': 'Tournaments in progress',
    'brak-turniejow-w-trakcie': 'No tournaments in progress',
    'szczegoly': 'Details',
    'edytuj': 'Edit',
    'usun': 'Delete',
    'data': 'Date',
    'miasto': 'City',
    'nazwa-turnieju': 'Tournament name',
    'typ': 'Type',
    'ilosc-graczy': 'Number of players',
    'gracz2': 'Player 2',
    'gracz3': 'Player 3',
    'rezerwowy': 'Reserve',
    'rezerwowy-przeciwnik': 'Opponent Reserve',
    'miejsce': 'Place',
    'typ-rundy': 'Round Type',
    'data-od': 'Date from',
    'data-do': 'Date to',
    'dodaj-turniej-button': 'Add tournament',
    'dodaj-nowy-turniej': 'Add new tournament',
    'data-required': 'Date *',
    'nazwa-turnieju-required': 'Tournament name *',
    'miasto-required': 'City *',
    'typ-required': 'Type *',
    'gracz2-required': 'Player 2 *',
    'gracz3-required': 'Player 3 *',
    'single': 'Single',
    'dublety': 'Doubles',
    'triplety': 'Triples',
    'triplety-z-rezerwowym': 'Triples with reserve',
    'anuluj': 'Cancel',
    'dodawanie': 'Adding...',
    'dodaj': 'Add',
    'potwierdzenie-usuniecia': 'Delete confirmation',
    'usuniecie-potwierdzenie-tekst': 'You are about to permanently delete tournament data. Are you sure?',
    'nie': 'No',
    'tak': 'Yes',
    'nieznany': 'Unknown',
    'wybierz-typ-rundy': 'Select round type',
    'wprowadz-wyniki-dla-obu-druzyn': 'Enter results for both teams',
    'wyniki-musza-byc-liczbami': 'Results must be numbers',
    'wyniki-musza-byc-miedzy-0-a-13': 'Results must be between 0 and 13',
    'petanque-nie-ma-remisow': 'In petanque there are no draws! Both teams\' scores must be different.',
    'zapisywanie': 'Saving...',
    'zapisz-zmiany': 'Save changes',
    'usuwanie': 'Deleting...',
    'tak': 'Yes',
    'rundy-turnieju': 'Tournament rounds',
    'dodaj-pierwsza-runde': 'Add first round',
    'typ-rundy': 'Round type',
    'wprowadz-nazwe-przeciwnika1': 'Enter Opponent 1 name',
    'wprowadz-nazwe-przeciwnika2': 'Enter Opponent 2 name',
    'wprowadz-nazwe-przeciwnika3': 'Enter Opponent 3 name',
    'wprowadz-nazwe-rezerwowego': 'Enter Reserve name',
    'zapisz-runde': 'Save round',
    'dodaj-runde': 'Add round',
    'dodaj-runde-breadcrumb': 'add round',
    'runda-buchholza': 'Buchholz round',
    'runda-pucharowa': 'Cup round',
    'runda-grupowa': 'Group round',
    'moja-druzyna': 'My team',
    'przeciwnicy': 'Opponents',
    'runda': 'Round',
    'puchar-buchholz-grupa': 'Cup/Buchholz/Group',
    'punkty-zdobyte': 'Points scored',
    'punkty-stracone': 'Points lost',
    'edytuj-runde': 'Edit round',
    'zakoncz-turniej': 'Finish tournament',
    'wybierz-typ': 'Select type',
    'przeglad-turniejow': 'tournament review',
    'zakonczone-turnieje': 'Finished tournaments',
    'filtry': 'Filters',
    'nazwa-turnieju-wymagana': 'Tournament name is required',
    'miasto-wymagane': 'City is required',
    'liczba-graczy-od': 'Players from',
    'liczba-graczy-do': 'Players to',
    'brak-zakonczonych-turniejow': 'No finished tournaments',
    'brak-turniejow-spelniajacych-kryteria': 'No tournaments matching search criteria',
    'typ-turnieju': 'Tournament type',
    'wszystkie': 'All',
    'twoja-druzyna': 'Your Team',
    'moja-druzyna-section': 'My Team',
    'wyniki-meczu-zapisane': 'Match results have been saved to the database.',
    'wynik-breadcrumb': 'result',
    'gra-zostala-pomyslnie-zapisana': 'Game has been successfully saved!',
    
    // Tournament Matches Page
    'przeglad-meczow-turniejowych': 'tournament matches review',
    'ladowanie-meczow': 'Loading matches...',
    'filtry': 'Filters',
    'gracz3': 'Player 3',
    'rezerwowy': 'Reserve',
    'przeciwnik1': 'Opponent 1',
    'przeciwnik2': 'Opponent 2',
    'przeciwnik3': 'Opponent 3',
    'rezerwowy-przeciwnik': 'Reserve opponent',
    'liczba-graczy': 'Number of players',
    'wszystkie': 'All',
    'single': 'Single',
    'dublety': 'Doubles',
    'triplety': 'Triples',
    'triplety-z-rezerwowym': 'Triples with reserve',
    'typ-rundy': 'Round type',
    'grupowa': 'Group',
    'pucharowa': 'Cup',
    'buchholz': 'Buchholz',
    'mecze-turniejowe': 'Tournament matches',
    'brak-meczow-spelniajacych-kryteria': 'No matches meet the search criteria',
    'edytuj': 'Edit',
    'usun': 'Delete',
    'czy-na-pewno-usunac-mecz': 'Are you sure you want to delete this match?',
    'blad-podczas-zapisywania': 'Error while saving',
    'blad-podczas-usuwania': 'Error while deleting',
    'brak-tokenu-autoryzacji': 'No authorization token. Please log in again.',
    'blad': 'Error',
    
    // Confirmation Modal
    'potwierdz-usuniecie': 'Confirm Deletion',
    'czy-na-pewno-usunac-mecz': 'Are you sure you want to delete this match?',
    'anuluj': 'Cancel',
    'usun': 'Delete',
    
    // Tournament Statistics Page
    'statystyki-turniejow': 'tournament statistics',
    
    // Tournament Match Statistics Page
    'statystyki-meczow-turniejowych': 'tournament match statistics',
    'ladowanie-danych': 'Loading data...',
    'blad-ladowania-statystyk': 'Error loading statistics',
    'sprobuj-ponownie': 'Try again',
    'zakres-czasowy': 'Time range',
    'wszystkie': 'All',
    'rok': 'Year',
    'miesiac': 'Month',
    'typ': 'Type',
    'buchholz': 'Buchholz',
    'pucharowe': 'Cup',
    'grupowe': 'Group',
    'wszystkie-mecze': 'All matches',
    'single': 'Single',
    'dublety': 'Doubles',
    'triplety': 'Triples',
    'wygrane': 'Won',
    'przegrane': 'Lost',
    'lacznie': 'Total',
    'meczow': 'matches',
    'srednie-punkty-w-czasie': 'Average points over time',
    'punkty-zdobyte': 'Points scored',
    'punkty-stracone': 'Points conceded',
    'numer-meczu': 'Match number',
    'srednie-punkty': 'Average points',
    'lacznie-meczow': 'Total matches',
    'brak-danych-do-wyswietlenia': 'No data to display',
    'dodaj-mecze-aby-zobaczyc-statystyki': 'Add matches to see statistics',
    'mecz': 'Match',
    'pkt-zdobyte': 'pts scored',
    'srednia': 'Average',
    // Settings Page
    'ustawienia': 'settings',
    'ustawienia-profilu-uzytkownika': 'User profile settings',
    'ladowanie': 'Loading...',
    'imie': 'First name',
    'nazwisko': 'Last name',
    'numer-licencji': 'License number',
    'klub': 'Club',
    'wybierz-klub': 'Select club',
    'miasto': 'City',
    'edytuj': 'Edit',
    'zapisz': 'Save',
    'anuluj': 'Cancel',
    'profil-zostal-zaktualizowany-pomyslnie': 'Profile updated successfully',
    'blad-aktualizacji-profilu': 'Profile update error',
    'imie-i-nazwisko-sa-obowiazkowe': 'First name and last name are required',
    'blad-pobierania-profilu-uzytkownika': 'Error fetching user profile',
    'blad-pobierania-listy-klubow': 'Error fetching clubs list',
    // Account Deletion Page
    'usun-konto': 'delete account',
    'czy-jestes-pewien-usunac-konto': 'Are you sure you want to delete your account? This is an irreversible process, after which your data will be deleted from the application.',
    'tak': 'Yes',
    'nie': 'No',
    // Registration Success Page
    'rejestracja-zakonczona-pomyslnie': 'Registration completed successfully',
    'rejestracja-zakonczona': 'Registration completed!',
    'dziekujemy-za-rejestracje': 'Thank you for registering! We have sent a verification email to the provided address.',
    'aby-aktywowac-konto': 'To activate your account, check your email inbox and click the verification link.',
    'po-weryfikacji-emaila': 'After email verification, you will be able to log in to the application.',
    'przejdz-do-strony-glownej': 'Go to main page',
    
    // Email verification page
    'email-verification': 'Email Verification',
    'invalid-verification-link': 'Invalid verification link. Check your email and try again.',
    'verifying-email': 'Verifying Email...',
    'please-wait-verification': 'Please wait while verifying your email address.',
    'email-verified': 'Email Verified!',
    'email-verified-success': 'Email has been successfully verified! You can now log in to your account.',
    'email-already-verified-success': 'Email has already been verified previously. You can now log in to your account.',
    'verification-failed': 'Verification failed. Please try again.',
    'verification-failed-title': 'Verification Failed',
    'contact-support-resend': 'Please contact support to resend verification email.',
    'resend-email': 'Resend Email',
    
    // Forgot Password page
    'password-reset': 'Password Reset',
    'forgot-password-title': 'Forgot Password',
    'forgot-password-description': 'Enter your email address and we will send you a password reset link.',
    'reset-password-button': 'Reset Password',
    'password-reset-link-sent': 'Password reset link has been sent to the provided email address.',
    'password-reset-error-sending': 'An error occurred while sending the link.',
    'back-to-login': 'Back to Login',
    'sending': 'Sending...',
    
    // Reset Password page
    'set-new-password': 'Set New Password',
    'new-password': 'New Password',
    'repeat-password': 'Repeat Password',
    'password-requirements': 'Password must be at least 8 characters, contain a digit and special character',
    'change-password': 'Change Password',
    'saving': 'Saving...',
    'invalid-reset-link': 'Invalid password reset link.',
    'password-reset-error': 'An error occurred while resetting the password.',
    'request-new-link': 'Request New Link',
    'error': 'Error',
    
    // Password Reset Success page
    'password-changed-successfully': 'Password Changed Successfully',
    'success': 'Success',
    'password-changed-message': 'Your password has been successfully changed. You can now log in using your new password.',
    'go-to-login': 'Go to Login',
    'main-page': 'Main Page',
  },
  
  fr: {
    // Navigation
    menu: 'menu',
    back: 'Retour',
    tournament: 'tournoi de classement',
    tournamentStats: 'statistiques des tournois',
    training: 'entraînement',
    friendlyGame: 'match amical',
    
    // Tournament Stats
    shootMe: 'ShootMe',
    allTournaments: 'Tous les tournois',
    tournamentsThisYear: 'Tournois de cette année',
    allGames: 'Tous les matchs',
    gamesThisYear: 'Matchs de cette année',
    firstPlaces: 'Premières places',
    secondPlaces: 'Deuxièmes places',
    thirdPlaces: 'Troisièmes places',
    topTenPlaces: 'Places dans le top dix',
    percentileDescription: 'joueurs jouant dans les mêmes tournois',
    thisYearPercentileDescription: 'joueurs jouant dans les mêmes tournois (moyenne de tous les tournois en',
    percentileChart: 'Percentile dans les 50 derniers tournois (moyenne mobile)',
    tournamentPercentile: 'Percentile du tournoi',
    averagePercentile: 'Percentile moyen',
    tournamentComparison: 'Comparaison des percentiles de tournoi',
    tournamentsChronologically: 'Tournois (chronologiquement)',
    percentile: 'Percentile (%)',
    
    // Loading and errors
    loadingStats: 'Chargement des statistiques...',
    connectionError: 'Erreur de connexion:',
    authError: 'Aucun token d\'autorisation. Veuillez vous reconnecter.',
    validatingSession: 'Validation de la session...',
    
    // Language names
    polish: 'Polski',
    english: 'English',
    french: 'Français',
    
    // Login page
    appDescription: 'Application pour suivre et analyser les résultats d\'entraînement de pétanque',
    login: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    loginButton: 'Connexion',
    forgotPassword: 'Mot de passe oublié',
    loginSuccessful: 'Connexion réussie !',
    loginFailed: 'Connexion échouée.',
    serverError: 'Erreur de connexion au serveur.',
    
    // Main page
    mainMenu: 'menu',
    training: 'entraînement',
    friendlyGame: 'match amical',
    tournament: 'tournoi de classement',
    settings: 'paramètres',
    
    // Pre-login page
    loginButton: 'Se connecter',
    registerButton: 'S\'inscrire',
    card1Title: 'Jouez. Enregistrez. Progressez.',
    card1Description: 'Suivez chaque lancer et touche',
    card2Title: 'Maîtrisez la précision',
    card2Description: 'Enregistrez facilement les résultats d\'entraînement de tir et de pointage',
    card3Title: 'C\'est l\'heure de jouer !',
    card3Description: 'Ajoutez les résultats de matchs amicaux et de tournois',
    card4Title: 'Vos statistiques, votre histoire',
    card4Description: 'Découvrez votre précision, tendances, séries de victoires',
    card5Title: 'Passez au niveau supérieur',
    card5Description: 'Observez vos progrès et savourez chaque petit succès',
    
    // Registration page
    registration: 'Inscription',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    password: 'Mot de passe',
    repeatPassword: 'Répéter le mot de passe',
    registerButton: 'S\'inscrire',
    firstNameError: 'Le prénom doit contenir au moins 2 caractères',
    lastNameError: 'Le nom de famille doit contenir au moins 2 caractères',
    passwordError: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordDigitError: 'Le mot de passe doit contenir au moins un chiffre',
    passwordSpecialError: 'Le mot de passe doit contenir au moins un caractère spécial',
    passwordMismatchError: 'Les mots de passe ne correspondent pas',
    passwordHint: 'Le mot de passe doit contenir au moins 8 caractères, un chiffre et un caractère spécial',
    registrationFailed: 'Inscription échouée.',
    serverError: 'Erreur de connexion au serveur.',
    
    // Main menu buttons
    logout: 'déconnexion',
    deleteAccount: 'supprimer le compte',
    
    // Training page
    trainingPage: 'entraînement',
    shotAtBall: 'tir sur boule',
    shotAtPig: 'tir sur cochonnet',
    highPoint: 'point haut',
    lowPoint: 'point bas',
    trainingReview: 'revue d\'entraînement',
    trainingStats: 'statistiques d\'entraînement',
    
    // Breadcrumbs
    '': 'menu',
    'trening': 'entraînement',
    'strzal-w-kule': 'tir sur boule',
    'strzal-w-swinke': 'tir sur cochonnet',
    'puenta-wysoka': 'point haut',
    'puenta-niska': 'point bas',
    'przeglad': 'revue d\'entraînement',
    'statystyki': 'statistiques d\'entraînement',
    'statystyki-meczow': 'statistiques des matchs',
    'mecz': 'match',
    'turniej-rankingowy': 'tournoi de classement',
    'dodaj': 'ajouter tournoi',
    'szczegoly': 'détails du tournoi',
    'dodaj-runde': 'ajouter ronde',
    'zakoncz': 'terminer tournoi',
    'mecze': 'revue des matchs de tournoi',
    'mecz-towarzyski': 'match amical',
    'dodaj-mecz': 'ajouter match',
    'przeglad-meczow': 'revue des matchs',
    'wynik': 'Résultat',
    'ustawienia': 'paramètres',
    'usun-konto': 'supprimer compte',
    'rejestracja': 'inscription',
    'logowanie': 'connexion',
    
    // Shot at Boule training page
    terrain: 'Terrain',
    weather: 'Météo',
    temperature: 'Température',
    date: 'Date',
    time: 'Heure',
    selectOption: 'Sélectionner...',
    distance: 'distance',
    carreau: 'carreau',
    hit: 'tir réussi',
    touch: 'touche',
    missed: 'raté',
    totalShots: 'total des lancers',
    totalAllShots: 'total de tous les lancers',
    saveTraining: 'Sauvegarder l\'entraînement',
    trainingSaved: 'Entraînement sauvegardé !',
    dateRequired: 'La date est requise.',
    saveError: 'Erreur de sauvegarde de l\'entraînement',
    serverConnectionError: 'Erreur de connexion au serveur.',
    
    // Training review page
    edit: 'Modifier',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    deleteTraining: 'Supprimer l\'entraînement',
    deleteTrainingConfirmation: 'Êtes-vous sûr de vouloir supprimer cet entraînement?',
    trainingUpdated: 'L\'entraînement a été mis à jour!',
    trainingDeleted: 'L\'entraînement a été supprimé!',
    noTrainingsDay: 'Aucun entraînement le jour sélectionné.',
    trainingDetails: 'Détails de l\'entraînement:',
    
    // Pointing training page columns
    '<20 cm': '<20 cm',
    '21-50 cm': '21-50 cm',
    '>50cm': '>50cm',
    
    // Calendar and training review
    clickDayForDetails: 'Cliquez sur un jour encerclé pour voir les détails de l\'entraînement.',
    months: {
      'January': 'Janvier',
      'February': 'Février',
      'March': 'Mars',
      'April': 'Avril',
      'May': 'Mai',
      'June': 'Juin',
      'July': 'Juillet',
      'August': 'Août',
      'September': 'Septembre',
      'October': 'Octobre',
      'November': 'Novembre',
      'December': 'Décembre'
    },
    
    // Statistics page
    training: 'entraînement',
    range: 'période',
    statistics: 'statistiques',
    distance: 'distance',
    day: 'jour',
    week: 'semaine',
    month: 'mois',
    year: 'année',
    hitCount: 'nombre de touches',
    hitPercentage: '% de touches',
    throwCount: 'nombre de lancers',
    all: 'tous',
    noData: 'Aucune donnée à afficher',
    forSelectedCriteria: 'pour les critères sélectionnés',
    chartTitle: 'Statistiques d\'entraînement',
    shotAtBoule: 'tir à la boule',
    shotAtCochonnet: 'tir au cochonnet',
    highPointing: 'pointage haut',
    lowPointing: 'pointage bas',
    
    // Chart legend labels
    carreau: 'carreau',
    carreauHit: 'carreau + tir réussi',
    carreauHitTouch: 'carreau + tir réussi + touche',
    hit: 'tir réussi',
    hitTouch: 'tir réussi + touche',
    throwCount: 'nombre de lancers',
    under20cm: '<20 cm',
    under50cm: '0-50 cm',
    over50cm: '>50 cm',
    
    // Friendly Game translations
    singiel: 'Tête-à-tête',
    dublet: 'Doublettes',
    triplet: 'Triplettes',
    twojaDruzyna: 'Votre Équipe',
    druzynaPrzeciwna: 'Équipe Adversaire',
    gracz: 'Joueur',
    rozpocznijMecz: 'Commencer le Match',
    wypelnijPola: 'Remplissez tous les champs (min. 3 caractères)',
    zapisz: 'Sauvegarder',
    zapisywanie: 'Sauvegarde...',
    anuluj: 'Annuler',
    edytuj: 'Modifier',
    usun: 'Supprimer',
    filtruj: 'Filtrer',
    wyczysc: 'Effacer',
    brakDanych: 'Aucune donnée à afficher. Ajoutez des matchs pour voir les statistiques.',
    ladowanieDanych: 'Chargement des données...',
    bladLadowania: 'Erreur de chargement des statistiques',
    sprobujPonownie: 'Réessayer',
    przejdzDoStronyGlownej: 'Aller à la page principale',
    pokazaneOstatnie: 'Affichage des 100 derniers matchs sur',
    dostepnych: 'disponibles',
    pokazaneWszystkie: 'Affichage de tous les',
    meczow: 'matchs',
    wszystkie: 'tous',
    rok: 'Année',
    miesiac: 'Mois',
    
    // Error messages
    wszyscyGraczeMin3Znaki: 'Tous les joueurs doivent avoir au moins 3 caractères dans leur nom',
    petanqueNieMaRemisow: 'En pétanque il n\'y a pas d\'égalité ! Les scores des deux équipes doivent être différents.',
    wystapilBladZapisywania: 'Une erreur s\'est produite lors de la sauvegarde du jeu',
    
    // Placeholder texts
    zalogowanyUzytkownik: 'Utilisateur connecté',
    wprowadzImieGracza: 'Entrez le nom du joueur',
    // Review page translations
    filtry: 'Filtres',
    gracz2: 'Joueur 2',
    gracz3: 'Joueur 3',
    przeciwnik1: 'Adversaire 1',
    przeciwnik2: 'Adversaire 2',
    przeciwnik3: 'Adversaire 3',
    dataOd: 'Date de',
    dataDo: 'Date à',
    liczbaGraczy: 'Nombre de joueurs',
    wszystkie: 'Tous',
    single: 'Simple',
    dublety: 'Doubles',
    triplety: 'Triples',
    brakMeczyKryteria: 'Aucun match ne correspond aux critères de recherche',
    dataICzas: 'Date et heure',
    gracz1: 'Joueur 1',
    akcje: 'Actions',
    brakTokenuAutoryzacji: 'Aucun token d\'autorisation. Veuillez vous reconnecter.',
    bladStatus: 'Erreur {status}: {text}',
    ladowanieDanychReview: 'Chargement des données...',
    bladReview: 'Erreur: {error}',
    // Stats page translations
    sredniePunktyWCzasie: 'Points moyens dans le temps',
    sredniePunktyZdobyte: 'Points moyens marqués',
    sredniePunktyStracone: 'Points moyens concédés',
    numerMeczu: 'Numéro de match',
    sredniePunkty: 'Points moyens',
    lacznieMeczow: 'Total des matchs',
    mecz: 'Match',
    pktZdobyte: 'pts marqués',
    srednia: 'Moyenne',
    pktStracone: 'pts concédés',
    wygrane: 'Gagnés',
    przegrane: 'Perdus',
    lacznie: 'Total',
    zakresCzasowy: 'Plage de temps',
    statystykiWygranychPrzegranych: 'Statistiques des victoires et défaites',
    nieMoznaOdczytaćOdpowiedzi: 'Impossible de lire la réponse du serveur',
    // Tournament translations
    'turniej-rankingowy': 'tournoi de classement',
    'dodaj-turniej': 'ajouter tournoi',
    'przeglad-turniejow': 'revue des tournois',
    'przeglad-meczow-turniejowych': 'revue des matchs de tournoi',
    'statystyki-turniejow': 'statistiques des tournois',
    'statystyki-meczow-turniejowych': 'statistiques des matchs de tournoi',
    'szczegoly-turnieju': 'détails du tournoi',
    'zakoncz-turniej': 'terminer le tournoi',
    'dodaj-runde': 'ajouter une ronde',
    'rundy': 'rondes',
    // AddTournament specific translations
    'turnieje-w-trakcie-rozgrywek': 'Tournois en cours',
    'brak-turniejow-w-trakcie': 'Aucun tournoi en cours',
    'szczegoly': 'Détails',
    'edytuj': 'Modifier',
    'usun': 'Supprimer',
    'data': 'Date',
    'miasto': 'Ville',
    'nazwa-turnieju': 'Nom du tournoi',
    'typ': 'Type',
    'ilosc-graczy': 'Nombre de joueurs',
    'gracz2': 'Joueur 2',
    'gracz3': 'Joueur 3',
    'rezerwowy': 'Réserviste',
    'rezerwowy-przeciwnik': 'Réserviste adversaire',
    'miejsce': 'Place',
    'typ-rundy': 'Type de ronde',
    'data-od': 'Date de',
    'data-do': 'Date à',
    'dodaj-turniej-button': 'Ajouter tournoi',
    'dodaj-nowy-turniej': 'Ajouter nouveau tournoi',
    'data-required': 'Date *',
    'nazwa-turnieju-required': 'Nom du tournoi *',
    'miasto-required': 'Ville *',
    'typ-required': 'Type *',
    'gracz2-required': 'Joueur 2 *',
    'gracz3-required': 'Joueur 3 *',
    'single': 'Tête-à-tête',
    'dublety': 'Doublettes',
    'triplety': 'Triplettes',
    'triplety-z-rezerwowym': 'Triplettes avec réserviste',
    'anuluj': 'Annuler',
    'dodawanie': 'Ajout...',
    'dodaj': 'Ajouter',
    'potwierdzenie-usuniecia': 'Confirmation de suppression',
    'usuniecie-potwierdzenie-tekst': 'Vous êtes sur le point de supprimer définitivement les données du tournoi. Êtes-vous sûr ?',
    'nie': 'Non',
    'tak': 'Oui',
    'nieznany': 'Inconnu',
    'wybierz-typ-rundy': 'Sélectionnez le type de ronde',
    'wprowadz-wyniki-dla-obu-druzyn': 'Entrez les résultats pour les deux équipes',
    'wyniki-musza-byc-liczbami': 'Les résultats doivent être des nombres',
    'wyniki-musza-byc-miedzy-0-a-13': 'Les résultats doivent être entre 0 et 13',
    'petanque-nie-ma-remisow': 'En pétanque il n\'y a pas d\'égalité ! Les scores des deux équipes doivent être différents.',
    'zapisywanie': 'Sauvegarde...',
    'zapisz-zmiany': 'Sauvegarder les modifications',
    'usuwanie': 'Suppression...',
    'tak': 'Oui',
    'rundy-turnieju': 'Rondes du tournoi',
    'dodaj-pierwsza-runde': 'Ajouter la première ronde',
    'typ-rundy': 'Type de ronde',
    'wprowadz-nazwe-przeciwnika1': 'Entrez le nom de l\'Adversaire 1',
    'wprowadz-nazwe-przeciwnika2': 'Entrez le nom de l\'Adversaire 2',
    'wprowadz-nazwe-przeciwnika3': 'Entrez le nom de l\'Adversaire 3',
    'wprowadz-nazwe-rezerwowego': 'Entrez le nom du Réserviste',
    'zapisz-runde': 'Sauvegarder la ronde',
    'dodaj-runde': 'Ajouter la ronde',
    'dodaj-runde-breadcrumb': 'ajouter la ronde',
    'runda-buchholza': 'Ronde Buchholz',
    'runda-pucharowa': 'Ronde de coupe',
    'runda-grupowa': 'Ronde de groupe',
    'moja-druzyna': 'Mon équipe',
    'przeciwnicy': 'Adversaires',
    'runda': 'Ronde',
    'puchar-buchholz-grupa': 'Coupe/Buchholz/Groupe',
    'punkty-zdobyte': 'Points marqués',
    'punkty-stracone': 'Points perdus',
    'edytuj-runde': 'Modifier la ronde',
    'zakoncz-turniej': 'Terminer le tournoi',
    'wybierz-typ': 'Sélectionner le type',
    'przeglad-turniejow': 'revue des tournois',
    'zakonczone-turnieje': 'Tournois terminés',
    'filtry': 'Filtres',
    'nazwa-turnieju-wymagana': 'Le nom du tournoi est requis',
    'miasto-wymagane': 'La ville est requise',
    'liczba-graczy-od': 'Joueurs de',
    'liczba-graczy-do': 'Joueurs à',
    'brak-zakonczonych-turniejow': 'Aucun tournoi terminé',
    'brak-turniejow-spelniajacych-kryteria': 'Aucun tournoi ne correspond aux critères de recherche',
    'typ-turnieju': 'Type de tournoi',
    'wszystkie': 'Tous',
    'twoja-druzyna': 'Votre Équipe',
    'moja-druzyna-section': 'Mon Équipe',
    'wyniki-meczu-zapisane': 'Les résultats du match ont été sauvegardés dans la base de données.',
    'wynik-breadcrumb': 'résultat',
    'gra-zostala-pomyslnie-zapisana': 'Le jeu a été sauvegardé avec succès !',
    
    // Tournament Matches Page
    'przeglad-meczow-turniejowych': 'revue des matchs de tournoi',
    'ladowanie-meczow': 'Chargement des matchs...',
    'filtry': 'Filtres',
    'gracz3': 'Joueur 3',
    'rezerwowy': 'Réserviste',
    'przeciwnik1': 'Adversaire 1',
    'przeciwnik2': 'Adversaire 2',
    'przeciwnik3': 'Adversaire 3',
    'rezerwowy-przeciwnik': 'Adversaire réserviste',
    'liczba-graczy': 'Nombre de joueurs',
    'wszystkie': 'Tous',
    'single': 'Tête-à-tête',
    'dublety': 'Doublettes',
    'triplety': 'Triplettes',
    'triplety-z-rezerwowym': 'Triplettes avec réserviste',
    'typ-rundy': 'Type de ronde',
    'grupowa': 'Groupe',
    'pucharowa': 'Coupe',
    'buchholz': 'Buchholz',
    'mecze-turniejowe': 'Matchs de tournoi',
    'brak-meczow-spelniajacych-kryteria': 'Aucun match ne correspond aux critères de recherche',
    'edytuj': 'Modifier',
    'usun': 'Supprimer',
    'czy-na-pewno-usunac-mecz': 'Êtes-vous sûr de vouloir supprimer ce match ?',
    'blad-podczas-zapisywania': 'Erreur lors de la sauvegarde',
    'blad-podczas-usuwania': 'Erreur lors de la suppression',
    'brak-tokenu-autoryzacji': 'Aucun token d\'autorisation. Veuillez vous reconnecter.',
    'blad': 'Erreur',
    
    // Confirmation Modal
    'potwierdz-usuniecie': 'Confirmer la suppression',
    'czy-na-pewno-usunac-mecz': 'Êtes-vous sûr de vouloir supprimer ce match ?',
    'anuluj': 'Annuler',
    'usun': 'Supprimer',
    
    // Tournament Statistics Page
    'statystyki-turniejow': 'statistiques de tournoi',
    
    // Tournament Match Statistics Page
    'statystyki-meczow-turniejowych': 'statistiques des matchs de tournoi',
    'ladowanie-danych': 'Chargement des données...',
    'blad-ladowania-statystyk': 'Erreur de chargement des statistiques',
    'sprobuj-ponownie': 'Réessayer',
    'zakres-czasowy': 'Plage de temps',
    'wszystkie': 'Tous',
    'rok': 'Année',
    'miesiac': 'Mois',
    'typ': 'Type',
    'buchholz': 'Buchholz',
    'pucharowe': 'Coupe',
    'grupowe': 'Groupe',
    'wszystkie-mecze': 'Tous les matchs',
    'single': 'Tête-à-tête',
    'dublety': 'Doublettes',
    'triplety': 'Triplettes',
    'wygrane': 'Gagnés',
    'przegrane': 'Perdus',
    'lacznie': 'Total',
    'meczow': 'matchs',
    'srednie-punkty-w-czasie': 'Points moyens dans le temps',
    'punkty-zdobyte': 'Points marqués',
    'punkty-stracone': 'Points concédés',
    'numer-meczu': 'Numéro de match',
    'srednie-punkty': 'Points moyens',
    'lacznie-meczow': 'Total des matchs',
    'brak-danych-do-wyswietlenia': 'Aucune donnée à afficher',
    'dodaj-mecze-aby-zobaczyc-statystyki': 'Ajoutez des matchs pour voir les statistiques',
    'mecz': 'Match',
    'pkt-zdobyte': 'pts marqués',
    'pkt-stracone': 'pts concédés',
    'srednia': 'Moyenne',
    // Settings Page
    'ustawienia': 'paramètres',
    'ustawienia-profilu-uzytkownika': 'Paramètres du profil utilisateur',
    'ladowanie': 'Chargement...',
    'imie': 'Prénom',
    'nazwisko': 'Nom de famille',
    'numer-licencji': 'Numéro de licence',
    'klub': 'Club',
    'wybierz-klub': 'Sélectionner un club',
    'miasto': 'Ville',
    'edytuj': 'Modifier',
    'zapisz': 'Enregistrer',
    'anuluj': 'Annuler',
    'profil-zostal-zaktualizowany-pomyslnie': 'Profil mis à jour avec succès',
    'blad-aktualizacji-profilu': 'Erreur de mise à jour du profil',
    'imie-i-nazwisko-sa-obowiazkowe': 'Le prénom et le nom de famille sont obligatoires',
    'blad-pobierania-profilu-uzytkownika': 'Erreur lors de la récupération du profil utilisateur',
    'blad-pobierania-listy-klubow': 'Erreur lors de la récupération de la liste des clubs',
    // Account Deletion Page
    'usun-konto': 'supprimer le compte',
    'czy-jestes-pewien-usunac-konto': 'Êtes-vous sûr de vouloir supprimer votre compte ? Il s\'agit d\'un processus irréversible, après lequel vos données seront supprimées de l\'application.',
    'tak': 'Oui',
    'nie': 'Non',
    // Registration Success Page
    'rejestracja-zakonczona-pomyslnie': 'Inscription terminée avec succès',
    'rejestracja-zakonczona': 'Inscription terminée !',
    'dziekujemy-za-rejestracje': 'Merci de vous être inscrit ! Nous avons envoyé un email de vérification à l\'adresse fournie.',
    'aby-aktywowac-konto': 'Pour activer votre compte, vérifiez votre boîte email et cliquez sur le lien de vérification.',
    'po-weryfikacji-emaila': 'Après vérification de l\'email, vous pourrez vous connecter à l\'application.',
    'przejdz-do-strony-glownej': 'Aller à la page principale',
    
    // Email verification page
    'email-verification': 'Vérification Email',
    'invalid-verification-link': 'Lien de vérification invalide. Vérifiez votre email et réessayez.',
    'verifying-email': 'Vérification Email...',
    'please-wait-verification': 'Veuillez patienter pendant la vérification de votre adresse email.',
    'email-verified': 'Email Vérifié !',
    'email-verified-success': 'L\'email a été vérifié avec succès ! Vous pouvez maintenant vous connecter à votre compte.',
    'email-already-verified-success': 'L\'email a déjà été vérifié précédemment. Vous pouvez maintenant vous connecter à votre compte.',
    'verification-failed': 'La vérification a échoué. Veuillez réessayer.',
    'verification-failed-title': 'Vérification Échouée',
    'contact-support-resend': 'Veuillez contacter le support pour renvoyer l\'email de vérification.',
    'resend-email': 'Renvoyer Email',
    
    // Forgot Password page
    'password-reset': 'Réinitialisation du mot de passe',
    'forgot-password-title': 'Mot de passe oublié',
    'forgot-password-description': 'Entrez votre adresse email et nous vous enverrons un lien de réinitialisation du mot de passe.',
    'reset-password-button': 'Réinitialiser le mot de passe',
    'password-reset-link-sent': 'Le lien de réinitialisation du mot de passe a été envoyé à l\'adresse email fournie.',
    'password-reset-error-sending': 'Une erreur s\'est produite lors de l\'envoi du lien.',
    'back-to-login': 'Retour à la connexion',
    'sending': 'Envoi en cours...',
    
    // Reset Password page
    'set-new-password': 'Définir un nouveau mot de passe',
    'new-password': 'Nouveau mot de passe',
    'repeat-password': 'Répéter le mot de passe',
    'password-requirements': 'Le mot de passe doit contenir au moins 8 caractères, un chiffre et un caractère spécial',
    'change-password': 'Changer le mot de passe',
    'saving': 'Enregistrement...',
    'invalid-reset-link': 'Lien de réinitialisation du mot de passe invalide.',
    'password-reset-error': 'Une erreur s\'est produite lors de la réinitialisation du mot de passe.',
    'request-new-link': 'Demander un nouveau lien',
    'error': 'Erreur',
    
    // Password Reset Success page
    'password-changed-successfully': 'Mot de passe modifié avec succès',
    'success': 'Succès',
    'password-changed-message': 'Votre mot de passe a été modifié avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    'go-to-login': 'Aller à la connexion',
    'main-page': 'Page principale',
  },
};

export const getTranslation = (key, language = 'pl') => {
  return translations[language]?.[key] || translations.pl[key] || key;
};
